// Action Types
export const UPDATE_MYTHIC_PLUS_CUTOFFS = 'UPDATE_MYTHIC_PLUS_CUTOFFS';

// Action Creators
const MythicPlusCutoffsActionCreator = {
  updateCutoffs(cutoffs: any) {
    return {
      type: UPDATE_MYTHIC_PLUS_CUTOFFS,
      payload: cutoffs
    };
  }
};

export default MythicPlusCutoffsActionCreator;
